import { Flex } from '@chakra-ui/layout';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { Loading } from '@revelio/core';

import { environment } from '../../environments/environment';
import { useBrand } from '../../shared/branding/brand-provider';
import { useHideNav } from '../../shared/hooks/useHideNav';
import { ImpersonationLinkGate } from '../adminRewrite/impersonation/ImpersonationLinkGate';
import Tutorial from '../tutorial/Tutorial';
import Welcome from '../tutorial/Welcome';
import { AuthGate } from './AuthGate';

export const PrivateRoute = ({ sessionToken }: { sessionToken?: string }) => {
  const isWhitelabel = useBrand().clientName !== 'default';
  const hideNav = useHideNav();

  const [isRequestingSessionCookie, setIsRequestingSessionCookie] = useState(
    !!sessionToken
  );

  useEffect(() => {
    if (!isRequestingSessionCookie) return;

    let cancelled = false;
    const fetchSessionCookie = async () => {
      try {
        const response = await fetch(
          `${environment.DASH_META_API}/api/session-auth/get-session`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ session_token: sessionToken }),
            credentials: 'include',
          }
        );
        if (!response.ok) {
          console.error(`Session token handoff failed: ${response.status}`);
        }
      } catch (error) {
        // Network/CORS failure: fall through to AuthGate, which re-validates.
        console.error('Session token handoff request failed', error);
      } finally {
        if (!cancelled) setIsRequestingSessionCookie(false);
      }
    };
    fetchSessionCookie();

    return () => {
      cancelled = true;
    };
  }, [sessionToken, isRequestingSessionCookie]);

  if (isRequestingSessionCookie) {
    return (
      <Flex height="100vh" bg="white">
        <Loading />
      </Flex>
    );
  }

  return (
    <AuthGate>
      <ImpersonationLinkGate>
        {!isWhitelabel && !hideNav && <Welcome />}
        <Tutorial />
        <Outlet />
      </ImpersonationLinkGate>
    </AuthGate>
  );
};
